// Which company the Finance Analyst ("Analytics" domain) is showing. Must match
// the backend's FINANCE_COMPANY so the dashboard and the agent's reports cover
// the same company. One of 'taurani', 'petronas' or 'sattva'; override with
// REACT_APP_FINANCE_COMPANY at build time.
export const FINANCE_COMPANY = (process.env.REACT_APP_FINANCE_COMPANY || 'taurani').toLowerCase();
